
import { Helmet } from "react-helmet";

const TietosuojaselosteePage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Tietosuojaseloste | Lainasampo.fi</title>
        <meta name="description" content="Lainasampo.fi:n tietosuojaseloste kertoo, miten käsittelemme henkilötietojasi ja mitä oikeuksia sinulla on." />
      </Helmet>

      <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-sm">
        <h1 className="text-3xl font-bold text-blue-800 mb-6">Tietosuojaseloste</h1>
        
        <div className="prose prose-blue max-w-none">
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Rekisterinpitäjä</h2>
          <p>
            Pulaton Oy vastaa Lainasampo.fi-palvelun tietosuojasta.
            <br />
            Y-tunnus: 3308199-4
            <br />
            Sähköposti: asiakaspalvelu@lainasampo.fi
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. Kerättävät tiedot</h2>
          <p>
            Keräämme seuraavia tietoja käyttäjiltä lainatarjousten käsittelyä varten:
          </p>
          <ul className="list-disc pl-5 mb-4">
            <li>Nimi ja yhteystiedot (sähköpostiosoite, puhelinnumero)</li>
            <li>Henkilötunnistetiedot</li>
            <li>Työllisyys- ja tulotiedot</li>
            <li>Lainaan liittyvät tiedot (haettu summa, tarkoitus, laina-aika)</li>
            <li>Taloudelliset tiedot (olemassa olevat lainat, menot)</li>
            <li>Tekniset tiedot (IP-osoite, selaintyyppi, laitetiedot)</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Tietojen käyttö</h2>
          <p>
            Käytämme tietojasi seuraaviin tarkoituksiin:
          </p>
          <ul className="list-disc pl-5 mb-4">
            <li>Lainahakemuksesi käsittelyyn</li>
            <li>Lainatarjousten pyytämiseen yhteistyökumppaneiltamme</li>
            <li>Viestintään kanssasi hakemukseesi liittyen</li>
            <li>Palvelumme ja käyttäjäkokemuksen parantamiseen</li>
            <li>Lakisääteisten velvoitteiden täyttämiseen</li>
            <li>Tilastolliseen analyysiin ja palvelun kehittämiseen</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Tietojen luovutus</h2>
          <p>
            Luovutamme tietojasi:
          </p>
          <ul className="list-disc pl-5 mb-4">
            <li>Yhteistyökumppaneillemme rahoituslaitoksille lainatarjousten tekemistä varten</li>
            <li>Palveluntarjoajille, jotka auttavat meitä verkkosivustomme ylläpidossa ja palveluidemme tarjoamisessa</li>
            <li>Viranomaisille lain vaatiessa</li>
          </ul>
          <p>
            Tietoja ei luovuteta markkinointitarkoituksiin ilman nimenomaista suostumustasi.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">5. Tietoturva</h2>
          <p>
            Toteutamme asianmukaiset tekniset ja organisatoriset toimenpiteet suojataksemme henkilötietojasi 
            luvattomalta pääsyltä, luovuttamiselta, muuttamiselta ja tuhoamiselta.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">6. Tietojen säilytys</h2>
          <p>
            Säilytämme tietojasi niin kauan kuin on tarpeen niiden tarkoitusten täyttämiseksi, joita 
            varten ne kerättiin, lakisääteisten velvoitteiden noudattamiseksi tai oikeutettujen etujemme suojaamiseksi.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">7. Oikeutesi</h2>
          <p>
            Sinulla on oikeus:
          </p>
          <ul className="list-disc pl-5 mb-4">
            <li>Saada pääsy henkilötietoihisi</li>
            <li>Oikaista virheellisiä henkilötietoja</li>
            <li>Pyytää henkilötietojesi poistamista</li>
            <li>Rajoittaa henkilötietojesi käsittelyä tai vastustaa sitä</li>
            <li>Tietojen siirrettävyyteen</li>
            <li>Peruuttaa suostumuksesi milloin tahansa</li>
          </ul>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">8. Yhteystiedot</h2>
          <p>
            Jos sinulla on kysyttävää tietosuojaselosteestamme tai siitä, miten käsittelemme henkilötietojasi, 
            ota yhteyttä:
            <br />
            Sähköposti: asiakaspalvelu@lainasampo.fi
          </p>
        </div>
      </div>
    </div>
  );
};

export default TietosuojaselosteePage;
